import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions, useMutation, useQueryClient } from 'react-query'
import { Tour } from 'components/ProductTour/Types'

interface Variables {
  tour: Tour
  step: number | true
}

type Data = {}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const updateUserCompletedProductTour = async ({ tour, step }: Variables) => {
  const res = await sendToApi<Data>(`/user_completed_product_tours`, { method: 'PATCH', body: { tour, step } })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data
}

export const useUpdateUserCompletedProductTour = (options?: Options) => {
  const queryClient = useQueryClient()

  return useMutation<Data, unknown, Variables>(
    ['user_completed_product_tours'],
    async (variables) => {
      const result = await updateUserCompletedProductTour({ ...variables })
      queryClient.invalidateQueries(['user_completed_product_tours'])
      return result
    },
    {
      ...options,
    },
  )
}
